module.exports = __webpack_public_path__ + "static/media/holy-relic-coromoto-370.0d0f026c.jpg";